module.exports = __webpack_public_path__ + "static/Recurring-Credit-Card-Form-f44d7595bfbbac10cf5c1996dce29b59.pdf";